import React from 'react'
import TraumTagSuperHost from '../assets/icons/traum-tag/super-host.svg'
import TraumTagGuestFriendly from '../assets/icons/traum-tag/guest-friendly.svg'
import TraumTagAward from '../assets/icons/traum-tag/award.svg'
import TraumTagLuxe from '../assets/icons/traum-tag/luxus.svg'
import TraumTagDogFriendly from '../assets/icons/traum-tag/dog-friendly.svg'
import TraumTagBeachHoliday from '../assets/icons/traum-tag/beach-holiday.svg'
import TraumTagPopularChoice from '../assets/icons/trending-up.svg'
import { getBasePath } from './miscellaneous-utils'

export enum TraumTagTypes {
    SUPER_HOST = 1,
    GUEST_FRIENDLY = 2,
    AWARD = 3,
    LUXE = 4,
    POPULAR_CHOICE = 5,
    HIDDEN_GEM = 6,
    DOG_FRIENDLY = 7,
    BEACH_HOLIDAY = 8,
}

interface TraumTagConfig {
    label: string
    Icon?: React.FC<React.SVGProps<SVGSVGElement>>
    imageUrl?: string
}

const TRAUM_TAGS: Record<number, TraumTagConfig> = {
    [TraumTagTypes.SUPER_HOST]: { label: 'traumTags.superHost', Icon: TraumTagSuperHost },
    [TraumTagTypes.GUEST_FRIENDLY]: { label: 'traumTags.guestFriendly', Icon: TraumTagGuestFriendly },
    [TraumTagTypes.AWARD]: { label: 'traumTags.award', Icon: TraumTagAward },
    [TraumTagTypes.LUXE]: { label: 'traumTags.luxe', Icon: TraumTagLuxe },
    [TraumTagTypes.DOG_FRIENDLY]: { label: 'traumTags.dogFriendly', Icon: TraumTagDogFriendly },
    [TraumTagTypes.BEACH_HOLIDAY]: { label: 'traumTags.beachHoliday', Icon: TraumTagBeachHoliday },
    [TraumTagTypes.POPULAR_CHOICE]: { label: 'traumTags.popularChoice', Icon: TraumTagPopularChoice },
    [TraumTagTypes.HIDDEN_GEM]: {
        label: 'traumTags.hiddenGem',
        imageUrl: getBasePath('/assets/images/traum-tags/tressure.png'),
    },
}

const PAID_BADGE_TAG_IDS = new Set([
    TraumTagTypes.SUPER_HOST,
    TraumTagTypes.GUEST_FRIENDLY,
    TraumTagTypes.AWARD,
    TraumTagTypes.LUXE,
    TraumTagTypes.DOG_FRIENDLY,
    TraumTagTypes.BEACH_HOLIDAY,
])

function isPaidBadgeTag(id: number): boolean {
    return PAID_BADGE_TAG_IDS.has(id)
}

export interface TraumTagData {
    id: number
    label: string
    Icon?: React.FC<React.SVGProps<SVGSVGElement>>
    imageUrl?: string
}

export interface CategorizedTraumTags {
    badgeTraumTags: TraumTagData[]
    popularChoiceTag: TraumTagData | undefined
    bottomTraumTags: TraumTagData[]
    hasBottomTags: boolean
}

export function getTraumTagsData(traumTagIds: number[] = [], showAbTestTags = false): CategorizedTraumTags {
    if (traumTagIds.length === 0) {
        return {
            badgeTraumTags: [],
            popularChoiceTag: undefined,
            bottomTraumTags: [],
            hasBottomTags: false,
        }
    }

    const badgeTraumTags: TraumTagData[] = []
    const bottomTraumTags: TraumTagData[] = []
    let popularChoiceTag: TraumTagData | undefined

    for (const id of traumTagIds) {
        const tag = TRAUM_TAGS[id]
        if (!tag) {
            continue
        }

        const traumTagData: TraumTagData = {
            id,
            label: tag.label,
            Icon: tag.Icon,
            imageUrl: tag.imageUrl,
        }

        if (isPaidBadgeTag(id)) {
            badgeTraumTags.push(traumTagData)
            continue
        }

        if (!showAbTestTags) {
            continue
        }

        if (id === TraumTagTypes.POPULAR_CHOICE) {
            popularChoiceTag = traumTagData
        }

        if (id === TraumTagTypes.HIDDEN_GEM) {
            bottomTraumTags.push(traumTagData)
        }
    }

    return {
        badgeTraumTags,
        popularChoiceTag,
        bottomTraumTags,
        hasBottomTags: bottomTraumTags.length > 0,
    }
}
